import { useEffect, useState } from "react";
import { Button, Icon, Modal, Spin } from "antd";
import StickerFull from "../../assets/stickers/full_sticker";

import "./styles.css";
import { useFreire } from "../../utils/freireContext";
import * as texts from "./locales";
import { useWhitelabels } from "../../components/WhitelabelThemesProvider";

const StickerModal = ({
  visible,
  station,
  qrcode,
  onClose,
  onDownload,
}) => {
  const [loadingSticker, setLoadingSticker] = useState(true);
  const { freire } = useFreire();
  const { selectedWhitelabelTheme } = useWhitelabels();

  useEffect(() => {
    async function delaySticker() {
      setLoadingSticker(true);
      try {
        await new Promise((resolve) => setTimeout(() => resolve(), 1250));
      } catch (error) {
        // pass
      } finally {
        setLoadingSticker(false);
      }
    }
    if (visible) delaySticker();
  }, [station, qrcode, visible, freire]);

  if (!selectedWhitelabelTheme) return null;

  const renderCustomSticker = () => {
    if (!selectedWhitelabelTheme.full_sticker) return null;
    return <StickerFull {...selectedWhitelabelTheme.full_sticker} qrcode={qrcode} station={station.code} />;
  };

  return (
    <Modal
      destroyOnClose
      width="70%"
      bodyStyle={{ padding: 15 }}
      centered
      title={"Adesivo Completo"}
      style={{ padding: 0 }}
      visible={visible}
      onCancel={() => onClose()}
      footer={
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          <Button key="cancel" onClick={() => onClose()}>
            {freire(texts.CLOSE)}
          </Button>
          <Button
            style={{ marginLeft: 25 }}
            key="ok"
            disabled={loadingSticker}
            type="primary"
            onClick={() => onDownload()}
          >
            {freire(texts.DOWNLOAD)}
            <Icon type="download" />
          </Button>
        </div>
      }
    >
      <div
        id="modalSticker"
        style={{
          position: "relative",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        {renderCustomSticker()}

        {loadingSticker ? (
          <div className="loadingSticker">
            <Spin />
          </div>
        ) : null}
      </div>
    </Modal>
  );
};

export default StickerModal;
